import React from 'react';
import { Box, IconButton, Tooltip, useTheme } from '@mui/material';
import {
  Delete as DeleteIcon,
  ContentCopy as DuplicateIcon,
} from '@mui/icons-material';
import { useConfirmDialog } from '../../../components/base/ConfirmDialog';

export const BulkStepActionsTrigger = ({ selectedSteps, onDeleteSteps, onDuplicateSteps }) => {
  const theme = useTheme();

  const { requestConfirm, ConfirmationDialog } = useConfirmDialog();
  const { requestConfirm: confirmDuplicate, ConfirmationDialog: DuplicationDialog } =
    useConfirmDialog();

  const handleDelete = async () => {
    const confirm = await requestConfirm();
    if (confirm) onDeleteSteps();
  };

  const handleDuplicate = async () => {
    const confirm = await confirmDuplicate();
    if (confirm) onDuplicateSteps();
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {/* Delete Action */}
      <Tooltip title="Delete selected steps">
        <IconButton
          onClick={handleDelete}
          size="small"
          sx={{
            color: theme.palette.error.main,
            '&:hover': {
              backgroundColor: theme.palette.error.light
            }
          }}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      {/* Duplicate Action */}
      <Tooltip title="Duplicate selected steps">
        <IconButton
          onClick={handleDuplicate}
          size="small"
          sx={{
            color: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.primary.light
            }
          }}>
          <DuplicateIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      {/* Confirmation Dialogs */}
      <ConfirmationDialog
        title={'Delete selected steps?'}
        description={'This action cannot be reversed and you may have to record them again.'}
        confirmLabel={'Delete'}
        cancelLabel={"Don't delete"}
        confirmColor={'error'}
      />
      <DuplicationDialog
        title={'Duplicate selected steps?'}
        description={
          "This will create exact copies of the selected steps. Changes to duplicates won't affect originals."
        }
        confirmLabel={'Duplicate'}
        cancelLabel={"Don't duplicate"}
        confirmColor={'primary'}
      />
    </Box>
  );
};
